import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import MaturatoAnalisiPieSet from "./MaturatoAnalisi.PieSet";
import MaturatoAnalisiKPISet from "./MaturatoAnalisi.KPISet";

const MaturatoAnalisi = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPIE = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Maturato')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <MaturatoAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPIE &&
                <Box className="report-itemgroup">
                    <MaturatoAnalisiPieSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }
        </Box>
    );
};

export default MaturatoAnalisi;
